<label [ngClass]="biggerFont ? 'fs-5' : ''" [for]="for"
  >{{ label | msg | async }} <span *ngIf="isRequired">*</span>
  <app-popover *ngIf="popoverInfo" [popoverInfo]="popoverInfo"></app-popover>
</label>
